import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import authService from '../services/authService'; // Servicio para la llamada al backend

const useAuth = () => {
  const { auth, login, logout } = useContext(AuthContext);
  
  if (!auth) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  const handleLogin = async (credentials) => {
    try {
      const { token, user, menus } = await authService.login(credentials);
      login(token, user, menus);
    } catch (error) {
      console.error("Error al iniciar sesión:", error);
      throw error; // Puedes manejar mejor los errores según tu necesidad
    }
  };

  const hasPermission = (code) => auth.user?.permissions?.includes(code) ?? false;

  const handleLogout = async () => {
    try {
      await authService.logout(); // Si tienes alguna llamada al backend para terminar la sesión
      logout();
    } catch (error) {
      console.error("Error al cerrar la sesión:",error);
      throw error;
    }
  };

  const handleChangePassword = (passwordData) =>
    authService.changePassword(passwordData);

  return {
    auth,
    handleLogin,
    handleLogout,
    handleChangePassword,
    hasPermission,
    isAuthenticated: auth.isAuthenticated,
  };
};

export default useAuth;
